import { r as registerInstance, h, a as Host, d as getElement } from './index-BntG-4Sv.js';
import { D as DropdownItem } from './dropdown-item-WQYHXM0G.js';
import { ServiceProvider, LanguageService, LanguageContextService, navigateTo, OperationStatus, OperationGroup, SubscriptionList, EventService, ResourceSearchStorageService, UriUtil, SearchButtonConfig, SearchButton, openInNewTab, service, RepositoryContextService, AutocompleteService, AutocompleteContextService, AutocompleteStorageService, OntoToastrService, NamespacesContextService, SuggestionType, SuggestionSelectedPayload, Suggestion, getCurrentRoute, navigate, AuthenticationService } from '@ontotext/workbench-api';
import { D as DropdownItemAlignment } from './dropdown-item-alignment-DghTf3pJ.js';
import { O as OntoTooltipPlacement } from './onto-tooltip-placement-D_J2-9CG.js';
import { T as TranslationService } from './translation.service-FB05Sh97.js';
import { H as HtmlUtil } from './html-util-C8DO915D.js';
import { R as ResourceSearchConstants } from './resource-search-constants-CY5yXafk.js';

const ontoLanguageSelectorCss = ":host{display:block}onto-language-selector{display:block}onto-language-selector .onto-dropdown{height:100%}onto-language-selector .onto-dropdown .onto-dropdown-button{background-color:transparent;color:var(--gw-button-tertiary-color);border:1px solid var(--gw-button-tertiary-border-color)}onto-language-selector .onto-dropdown .onto-dropdown-button .button-icon{color:var(--gw-button-tertiary-icon-color)}onto-language-selector .onto-dropdown .onto-dropdown-button:hover{background-color:var(--gw-button-tertiary-hover-background);color:var(--gw-button-tertiary-hover-color);border:1px solid var(--gw-button-tertiary-hover-border-color)}onto-language-selector .onto-dropdown.open{color:var(--gw-button-tertiary-color);background-color:var(--gw-button-tertiary-background);border-color:var(--gw-button-tertiary-border-color)}onto-language-selector .onto-dropdown.open .onto-dropdown-button{height:fit-content}";

const OntoLanguageSelector = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.languageService = ServiceProvider.get(LanguageService);
        this.languageContextService = ServiceProvider.get(LanguageContextService);
        this.items = [];
        /**
         * Specifies the dropdown items' alignment. If not provided, the items and the dropdown button will be aligned to the left.
         *
         */
        this.dropdownAlignment = DropdownItemAlignment.LEFT;
    }
    connectedCallback() {
        this.onLanguageChangeSubscription = this.languageContextService.onSelectedLanguageChanged((newLanguage) => this.changeLanguage(newLanguage));
        this.items = this.getLanguageDropdownOptions();
    }
    disconnectedCallback() {
        if (this.onLanguageChangeSubscription) {
            this.onLanguageChangeSubscription();
        }
    }
    render() {
        var _a, _b;
        return (h(Host, { key: '5e491919613ecaa0ce41fe401d33703e2cc3d150' }, h("onto-dropdown", { key: 'ae8cd90f64c2a7bc142c03d8e67e8574e860d71f', class: 'onto-language-selector', onValueChanged: this.valueChangeHandler(), dropdownButtonNameLabelKey: !this.currentLanguage ? 'language_selector.toggle_menu.label' : undefined, dropdownButtonName: (_a = this.currentLanguage) !== null && _a !== void 0 ? _a : undefined, dropdownButtonTooltipLabelKey: this.currentLanguage ? 'language_selector.toggle_menu.tooltip' : 'language_selector.toggle_menu.label', dropdownAlignment: (_b = this.dropdownAlignment) !== null && _b !== void 0 ? _b : DropdownItemAlignment.RIGHT, iconClass: 'ri-translate-2', items: this.items, "auto-close": true })));
    }
    valueChangeHandler() {
        return (newLanguage) => this.onSelectedLanguageChanged(newLanguage);
    }
    changeLanguage(newLanguage) {
        let selectedLanguage = newLanguage;
        if (!selectedLanguage) {
            selectedLanguage = this.languageService.getDefaultLanguage();
        }
        this.currentLanguage = selectedLanguage;
        this.items = this.getLanguageDropdownOptions();
    }
    onSelectedLanguageChanged(newLanguageEvent) {
        this.languageContextService.updateSelectedLanguage(newLanguageEvent.detail);
    }
    getLanguageDropdownOptions() {
        return this.languageService.getSupportedLanguages().map((locale) => {
            const iconClass = this.currentLanguage === locale ? 'ri-check-line' : '';
            return new DropdownItem()
                .setNameLabelKey(`language_selector.language.${locale}.label`)
                .setTooltipLabelKey(`language_selector.language.${locale}.tooltip.` + (this.currentLanguage === locale ? 'selected' : 'not_selected'))
                .setIconClass(iconClass)
                .setCssClass(locale)
                .setValue(locale);
        });
    }
};
OntoLanguageSelector.style = ontoLanguageSelectorCss;

const ontoLicenseAlertCss = ":host{display:block}.onto-license-alert{animation:fade-button 2s infinite;--fade-color:var(--gw-error-light);border:1px solid transparent !important}.onto-license-alert:hover{text-decoration:none;background-color:var(--gw-error-light) !important;border-color:var(--gw-error-light) !important}.onto-license-alert:hover span{transform:scale(1.2)}.onto-license-alert span{transition:transform 0.15s ease-out}.onto-license-alert .ri-alert-line{margin-right:0.2em;line-height:0.75;font-size:1.4em;display:inline-block;vertical-align:middle}";

const OntoLicenseAlert = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
    }
    render() {
        var _a;
        return (h(Host, { key: '149648585dca47d929543511ce36d472ac49bf2a', "tooltip-content": (_a = this.license) === null || _a === void 0 ? void 0 : _a.message, "tooltip-placement": OntoTooltipPlacement.BOTTOM, "data-test": 'onto-license-alert' }, h("button", { key: '3543436051869248024f2110f240d4a11461c591', class: "onto-license-alert onto-btn", onClick: navigateTo('license') }, h("span", { key: '87a59b584d34508bc8d91a0b4ec065fb3fe2c5bf', class: "ri-alert-line" }), h("translate-label", { key: 'c815a7badf2cbb2f4589194b4473f0cf2551a0a1', labelKey: 'license_alert.label' }))));
    }
};
OntoLicenseAlert.style = ontoLicenseAlertCss;

const ontoOperationsNotificationCss = ".operations-statuses{position:relative;background-color:transparent}.operations-statuses .operations-statuses-content i{padding-left:3px;padding-right:3px;font-size:1.1em;line-height:1.6rem !important;align-content:center;transition:transform 0.15s ease-out}.operations-statuses .operations-statuses-dropdown-toggle{display:flex;font-weight:400;line-height:1.25;text-align:center;white-space:nowrap;vertical-align:middle;cursor:pointer;user-select:none;background-color:transparent;border:1px solid var(--gw-button-tertiary-border-color);padding:0.4rem 1rem;gap:0.75em;transition:all 0.15s ease-out}.operations-statuses .operations-statuses-dropdown-toggle .operation-status-icon,.operations-statuses .operations-statuses-dropdown-toggle .ri-arrow-down-s-line{color:var(--gw-button-tertiary-icon-color)}.operations-statuses .operations-statuses-dropdown-toggle:hover i:not(.ri-arrow-down-s-line){transform:scale(1.2)}.operations-statuses .operations-statuses-dropdown-toggle:focus{outline:none}.operations-statuses .operations-statuses-dropdown-toggle .operation-status-header{display:flex}.operations-statuses .operations-statuses-dropdown-toggle .operation-status-header .running-operation-count{line-height:1.7;display:inline;min-width:1rem;height:1rem;padding:0 6px;background-color:var(--gw-badge-primary-background);color:var(--gw-badge-primary-color);font-size:0.625rem;font-weight:600}.operations-statuses .operations-dropdown{position:absolute;right:0;z-index:1000;background-color:var(--gw-contextmenu-background);border:1px solid var(--gw-contextmenu-border-color);color:var(--gw-contextmenu-color);list-style:none;padding:0;-moz-transition:all 150ms ease-out;-o-transition:all 150ms ease-out;-webkit-transition:all 150ms ease-out;transition:all 150ms ease-out}.operations-statuses .operations-dropdown .operations-statuses-content{display:flex;flex-direction:column;margin:0}.operations-statuses .operations-dropdown .operations-statuses-content li:first-child{margin-top:5px}.operations-statuses .operations-dropdown .operations-statuses-content li:last-child{margin-bottom:5px}.operations-statuses .operations-dropdown .operation-status-content{display:flex;flex-direction:row;margin:5px 10px;align-items:center;justify-content:start;cursor:pointer;text-decoration:none;width:auto;gap:0.5em}.operations-statuses .operations-dropdown .operation-status-content.status-warning{background-color:var(--gw-button-warn-background);border:1px solid var(--gw-button-warn-border-color);color:var(--gw-button-warn-color)}.operations-statuses .operations-dropdown .operation-status-content.status-warning:hover{background-color:var(--gw-button-warn-hover-background);border:1px solid var(--gw-button-warn-hover-border-color);color:var(--gw-button-warn-hover-color)}.operations-statuses .operations-dropdown .operation-status-content.status-critical{background-color:var(--gw-button-danger-background);border:1px solid var(--gw-button-danger-border-color);color:var(--gw-button-danger-color)}.operations-statuses .operations-dropdown .operation-status-content.status-critical:hover{background-color:var(--gw-button-danger-hover-background);border:1px solid var(--gw-button-danger-hover-border-color);color:var(--gw-button-danger-hover-color)}.operations-statuses .operations-dropdown .operation-status-content .operation-number{min-width:50px;display:block}.operations-statuses .operations-dropdown .operation-status-content .operation-number .operation-status-running-operation-count{display:inline;min-width:1rem;height:1rem;padding:2px 6px;background-color:var(--gw-badge-primary-background);color:var(--gw-badge-primary-color);font-size:0.625rem;font-weight:600}.operations-statuses .operations-dropdown .operation-status-content .operation-status-content>*{padding:0}.operations-statuses .operations-dropdown .operation-status-content .operation-status-label{width:66.66%;padding-left:5px;line-height:0;text-align:start}.operations-statuses .operations-dropdown .operation-status-content:hover{text-decoration:none;color:var(--gw-button-tertiary-hover-color);background-color:var(--gw-button-tertiary-hover-background)}.operations-statuses .operations-dropdown .operation-status-content:hover i{transform:scale(1.2)}.operations-statuses .operations-dropdown .operation-status-content.status-information{background-color:var(--gw-button-tertiary-background);border:1px solid var(--gw-button-tertiary-border-color);color:var(--gw-button-tertiary-color)}.operations-statuses .operations-dropdown .operation-status-content.status-information:hover{background-color:var(--gw-button-tertiary-hover-background);border:1px solid var(--gw-button-tertiary-hover-border-color);color:var(--gw-button-tertiary-hover-color)}";

const operationGroupToIcon = {
    [OperationGroup.BACKUP]: 'ri-archive-line',
    [OperationGroup.QUERY]: 'ri-arrow-left-right-line',
    [OperationGroup.CLUSTER]: 'ri-organization-chart',
    [OperationGroup.IMPORT]: 'icon-import'
};
const operationStatusToWarningClass = {
    [OperationStatus.WARNING]: 'status-warning',
    [OperationStatus.INFORMATION]: 'status-information',
    [OperationStatus.CRITICAL]: 'status-critical'
};
const operationStatusToFadeClass = {
    [OperationStatus.WARNING]: 'onto-btn-fade-warning',
    [OperationStatus.CRITICAL]: 'onto-btn-fade-danger'
};
const OntoOperationsNotification = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /** Whether the dropdown menu is open or closed */
        this.isOpen = false;
        this.toggleDropdown = (event) => {
            event.stopPropagation();
            this.isOpen = !this.isOpen;
        };
    }
    handleOutsideClick() {
        if (this.isOpen) {
            this.isOpen = false;
        }
    }
    render() {
        var _a;
        this.operationGroups = this.activeOperations.toOperationGroupSummaryList();
        return (h("section", { key: 'c4ed5b693c399a3b3d57cdefcca5828d55a67de3', class: "operations-statuses" }, h("button", { key: '994dc049b42836ade271a3fc0076bee5a2b95570', class: `operations-statuses-dropdown-toggle ${this.isOpen ? 'open' : 'closed'} ${(_a = operationStatusToFadeClass[this.activeOperations.status]) !== null && _a !== void 0 ? _a : ''}`, onClick: this.toggleDropdown }, this.operationGroups.getItems().map((groupSummary) => (h("section", { key: groupSummary.id, class: "operation-status-header" }, h("i", { class: `operation-status-icon icon-1-33x ${operationGroupToIcon[groupSummary.group]} ${operationStatusToWarningClass[groupSummary.status]}` }), groupSummary.totalOperations
            ? h("sup", { class: "running-operation-count" }, groupSummary.totalOperations)
            : ''))), h("i", { key: 'eb093116742efd2a231011b2a45dfc67ebc8a9d4', class: `ri-arrow-down-s-line ${this.isOpen ? 'rotate-180' : ''}` })), this.isOpen &&
            h("ul", { key: '75ef54df0350f9beda3acf4fece801da8eef6dff', class: "operations-dropdown" }, h("section", { key: '929302253ab9f1d43aa77e40fa78862c093222d5', class: "operations-statuses-content" }, this.activeOperations.allRunningOperations.getItems().map((operation) => (h("li", { key: operation.id }, h("a", { class: `operation-status-content onto-btn no-underline ${operationStatusToWarningClass[operation.status]}`, target: "_blank", onClick: navigateTo(operation.href) }, h("i", { class: operationGroupToIcon[operation.group] }), h("span", { class: "operation-status-label" }, h("translate-label", { labelKey: `operations_notification.links.${operation.labelKey}` })), h("span", { class: "operation-number" }, operation.count
                ? h("span", { class: "operation-status-running-operation-count" }, operation.count)
                : '')))))))));
    }
    get el() { return getElement(this); }
};
OntoOperationsNotification.style = ontoOperationsNotificationCss;

const ontoRdfSearchCss = ".onto-rdf-search{display:flex;align-items:center;height:auto}.onto-rdf-search .search-area{white-space:nowrap;text-align:start;font-weight:300;max-width:100vw;position:fixed;right:3em;z-index:1;display:block;width:60vw;-webkit-transition:top 0.3s ease-in, opacity 0.5s ease;transition:top 0.3s ease-in, opacity 0.5s ease;border-radius:0;margin-bottom:1em;padding:1.6rem;color:var(--gw-dialog-color);background-color:var(--gw-dialog-background);border:1px solid var(--gw-dialog-border-color);box-shadow:var(--gw-dialog-shadow-1-offset-x) var(--gw-dialog-shadow-1-offset-y) var(--gw-dialog-shadow-1-blur) var(--gw-dialog-shadow-1-spread) var(--gw-dialog-shadow-1-color)}.onto-rdf-search .search-area.visible{top:40px;opacity:1}.onto-rdf-search .search-area.invisible{top:-550px;opacity:0}.onto-rdf-search .search-area .close-btn{display:block;position:absolute;top:0;right:0;font-size:1.5rem}.onto-rdf-search i{cursor:pointer;color:var(--gw-button-tertiary-icon-color);transition:all 0.15s ease-out}.onto-rdf-search i.ri-search-line,.onto-rdf-search i.close-btn{padding:0.5rem 0.8rem}.onto-rdf-search i:hover{transform:scale(1.2)}";

const OntoRdfSearch = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.subscriptions = new SubscriptionList();
        this.eventService = ServiceProvider.get(EventService);
        this.resourceSearchStorageService = ServiceProvider.get(ResourceSearchStorageService);
        this.RDF_CONTEXT = 'rdfSearchContext';
        this.isOpen = false;
        this.redirectUrl = UriUtil.RESOURCE_URL;
    }
    /**
     * Handles click events on the window.
     * Closes the search area if it's open and the click is outside the search area.
     * @param event - The MouseEvent object.
     */
    handleClick(event) {
        var _a;
        if (!this.isOpen) {
            return;
        }
        if (!((_a = this.rdfSearchRef) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
            this.isOpen = false;
        }
    }
    connectedCallback() {
        this.onSuggestionSelected();
    }
    disconnectedCallback() {
        this.subscriptions.unsubscribeAll();
    }
    componentDidRender() {
        this.focusSearchInput();
    }
    componentDidLoad() {
        this.buttonConfig = this.createButtonConfig();
    }
    render() {
        return (h("section", { key: 'a16597d4d9c0916463354f2165efbe4a49942bba', ref: (ref) => this.rdfSearchRef = ref, class: "onto-rdf-search", onKeyDown: this.onKeyDown(), "data-test": 'onto-rdf-search-component' }, h("section", { key: 'bbe25fab5cc4fdda207b0faa70a4ef29d59dd6bb', class: `search-area ${this.isOpen ? 'visible' : 'invisible'}` }, h("i", { key: '666e4a4d93a6b72d3561cd52cf5fa1d3de1e778c', onClick: this.setIsOpen(false), "tooltip-content": TranslationService.translate('rdf_search.tooltips.close_search_area'), "tooltip-placement": OntoTooltipPlacement.BOTTOM, "data-test": 'onto-rdf-resource-search-close-btn', class: "ri-close-line close-btn" }), h("onto-search-resource-input", { key: 'c01c6d6c8e1f9f7c2c0db077c78735e56ac67112', buttonConfig: this.buttonConfig, preserveSearch: true, isHidden: !this.isOpen, "data-test": 'onto-rdf-resource-search-input', context: this.RDF_CONTEXT })), !this.isOpen ? h("onto-search-icon", { onClick: this.setIsOpen(true) }) : ''));
    }
    /**
     * Creates a function to set the open state of the search area.
     * @param isOpen - Boolean indicating whether the search area should be open.
     */
    setIsOpen(isOpen) {
        return () => {
            this.isOpen = isOpen;
            if (this.isOpen) {
                this.loadSelectedViewFromStorage();
            }
        };
    }
    /**
     * Creates the configuration for search buttons.
     * @returns A SearchButtonConfig object with radio buttons for table and visual search.
     */
    createButtonConfig() {
        return new SearchButtonConfig({
            isRadio: true,
            buttons: [
                this.createSearchButton(ResourceSearchConstants.TABLE_VIEW, 'rdf_search.buttons.table', () => {
                    this.redirectUrl = UriUtil.RESOURCE_URL;
                    this.resourceSearchStorageService.setSelectedView(ResourceSearchConstants.TABLE_VIEW);
                }, true),
                this.createSearchButton(ResourceSearchConstants.VISUAL_VIEW, 'rdf_search.buttons.visual', () => {
                    this.redirectUrl = UriUtil.GRAPHS_VISUALIZATIONS_URL;
                    this.resourceSearchStorageService.setSelectedView(ResourceSearchConstants.VISUAL_VIEW);
                }, false)
            ]
        });
    }
    /**
     * Creates a search button with the given parameters.
     * @param id - The id for the button.
     * @param labelKey - The key for the button's label translation.
     * @param callback - The function to be called when the button is clicked.
     * @param selected - Boolean indicating whether the button should be initially selected.
     * @returns A SearchButton object.
     */
    createSearchButton(id, labelKey, callback, selected) {
        return new SearchButton({
            label: TranslationService.translate(labelKey),
            id,
            callback,
            selected
        });
    }
    onSuggestionSelected() {
        this.subscriptions.add(this.eventService.subscribe(ResourceSearchConstants.SUGGESTION_SELECTED_EVENT, (payload) => {
            if (payload.getContext() === this.RDF_CONTEXT) {
                const redirectUrl = payload.getSuggestion().getOverrideToVisual()
                    ? UriUtil.GRAPHS_VISUALIZATIONS_URL
                    : this.redirectUrl;
                openInNewTab(UriUtil.createAutocompleteRedirect(redirectUrl, payload.getSuggestion().getValue()));
            }
        }));
    }
    onKeyDown() {
        return (event) => {
            if (event.key === 'Escape') {
                this.isOpen = false;
            }
        };
    }
    focusSearchInput() {
        if (this.isOpen) {
            HtmlUtil.focusElement(`#${this.RDF_CONTEXT}`);
        }
    }
    loadSelectedViewFromStorage() {
        const selectedView = this.resourceSearchStorageService.getSelectedView();
        if (selectedView) {
            const selectedButton = this.buttonConfig.getButtons().find((button) => button.id === selectedView);
            if (selectedButton) {
                this.buttonConfig = this.buttonConfig.selectButton(selectedButton);
            }
        }
    }
};
OntoRdfSearch.style = ontoRdfSearchCss;

/**
 *
 * A StencilJS component that renders a repository selection. The element displays the repository's icon and ID
 * if a repository is selected; otherwise, it shows a translated toggle button name. The component dynamically
 * updates the name when the translation changes.
 *
 * @example
 * <RepositorySelection repository={repository}></>
 *
 */
const RepositorySelection = ({ repository, defaultToggleButtonName, location }) => {
    var _a;
    const className = repository ? 'repository-selection active-repository' : 'repository-selection no-selected-repository';
    return (h("div", { class: className, "data-test": 'repository-selection' },
        repository && h("i", { class: 'button-icon icon-1-5x icon-repo-' + repository.type }),
        "\u00A0", (_a = repository === null || repository === void 0 ? void 0 : repository.id) !== null && _a !== void 0 ? _a : defaultToggleButtonName,
        location));
};

const ontoRepositorySelectorCss = ":host{display:block}.onto-repository-selector .onto-dropdown.closed .onto-dropdown-button:not(:hover){background-color:transparent}.onto-repository-selector .repository-selector-dropdown-item{display:flex;align-items:center;gap:0.4em}.onto-repository-selector .repository-selector-dropdown-item .item-icon{font-size:1.4em}.onto-repository-selector .repository-selector-dropdown-item .item-label{line-height:0.75em;display:inline-block;vertical-align:middle;text-align:left}.onto-repository-selector .repository-selector-dropdown-item .item-label .repository-id{line-height:0.75em}.onto-repository-selector .repository-selector-dropdown-item .item-label .repository-location{font-weight:300;font-size:0.75em;margin-top:0.4em;display:inline-block;max-width:120px;text-overflow:ellipsis;overflow:hidden}.tooltip-box[data-theme=light-border]{color:var(--gw-dialog-color) !important;background-color:var(--gw-dialog-background) !important;border:1px solid var(--gw-dialog-border-color) !important;box-shadow:var(--gw-dialog-shadow-1-offset-x) var(--gw-dialog-shadow-1-offset-y) var(--gw-dialog-shadow-1-blur) var(--gw-dialog-shadow-1-spread) var(--gw-dialog-shadow-1-color);max-width:350px;opacity:1 !important}.tooltip-box[data-theme=light-border] .tooltip-arrow::before{border:1px solid var(--gw-dialog-border-color);background-color:var(--gw-dialog-background)}.tooltip-box[data-theme=light-border] .tooltip-content{padding:0}.tooltip-box[data-theme=light-border] .tooltip-content .repository-tooltip-title{font-size:1rem;font-weight:400;padding:8px 14px;background-color:var(--gw-dialog-background);border-bottom:var(--gw-dialog-border-color) 1px solid}.tooltip-box[data-theme=light-border] .tooltip-content .repository-tooltip-title .value{overflow-wrap:break-word}.tooltip-box[data-theme=light-border] .tooltip-content .repository-tooltip-content{background-color:var(--gw-dialog-background);padding:1.5rem 0.5rem;display:flex;flex-direction:column;gap:0.8em;font-weight:400;font-size:0.875rem}.tooltip-box[data-theme=light-border] .tooltip-content .repository-tooltip-row{display:flex;flex-direction:row;justify-content:space-between}.tooltip-box[data-theme=light-border] .tooltip-content .repository-tooltip-row.total{margin-top:1.2em}.tooltip-box[data-theme=light-border] .tooltip-content .repository-tooltip-row .value{margin-left:0.6em}";

const OntoRepositorySelector = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.repositoryContextService = service(RepositoryContextService);
        this.subscriptions = [];
    }
    /**
     * Re-applies tooltip functions to all dropdown items when the items prop changes.
     */
    onItemsChanged(newItems) {
        if (!(newItems === null || newItems === void 0 ? void 0 : newItems.length)) {
            this.dropdownItems = [];
            return;
        }
        this.dropdownItems = this.attachTooltipsToItems(this.items);
    }
    connectedCallback() {
        var _a;
        this.subscriptions.push(...this.subscribeToTranslationChanged());
        // Manually apply tooltip functions to each item on first mount.
        if ((_a = this.items) === null || _a === void 0 ? void 0 : _a.length) {
            this.dropdownItems = this.attachTooltipsToItems(this.items);
        }
        else {
            this.dropdownItems = [];
        }
    }
    /**
     * Cleans up the subscriptions when the component is removed from the DOM to avoid memory leaks.
     * This method unsubscribes from both the repository change and selected repository change events.
     */
    disconnectedCallback() {
        this.subscriptions.forEach((subscription) => subscription());
    }
    render() {
        const repositorySelection = h(RepositorySelection, { key: '99a634bdf687d02a1c342ca9bd594e22374ec645', repository: this.currentRepository, defaultToggleButtonName: this.getButtonLabel(), location: this.getLocation() });
        return (h(Host, { key: '2d85f368ae744cee9b2ba7733b87a0da3ecd69c2' }, h("onto-dropdown", Object.assign({ key: 'bcb1d5c064b009f2c4ad6792d14405b354c09082', class: "onto-repository-selector", "data-test": 'onto-repository-selector', onValueChanged: this.onValueChanged(), dropdownButtonName: repositorySelection, dropdownButtonTooltip: this.createTooltipFunctionForRepository(this.currentRepository) }, (this.currentRepository ? { 'dropdownButtonGuideSelector': `repository-id-${this.currentRepository.id}` } : {}), { dropdownAlignment: DropdownItemAlignment.RIGHT, tooltipPlacement: this.tooltipAlignment, tooltipTheme: "light-border", items: this.dropdownItems, "auto-close": true }))));
    }
    attachTooltipsToItems(items) {
        if (!items) {
            return [];
        }
        return items.map((item) => item.setTooltip(this.createTooltipFunctionForRepository(item.value)));
    }
    tooltipAlignment(isOpen) {
        if (isOpen) {
            return OntoTooltipPlacement.LEFT;
        }
        return OntoTooltipPlacement.BOTTOM;
    }
    onValueChanged() {
        return (valueChangeEvent) => this.onRepositoryChanged(valueChangeEvent.detail);
    }
    /**
     * Returns an async function that generates HTML tooltip content for the given repository.
     */
    createTooltipFunctionForRepository(repository) {
        return async () => {
            if (!repository) {
                return '';
            }
            const repositorySizeInfo = await this.repositorySizeInfoFetcher(repository);
            return this.buildRepositoryTooltipHtml(repository, repositorySizeInfo);
        };
    }
    /**
     * Builds the complete HTML string used as tooltip content for a repository.
     */
    buildRepositoryTooltipHtml(repository, repositorySizeInfo) {
        let html = `
    <div class="repository-tooltip-title">
      <span class="label">${TranslationService.translate('repository-selector.tooltip.repository')}</span>
      <span class="value">${repository.id}</span>
    </div>
    <div class="repository-tooltip-content">
      <div class="repository-tooltip-row">
        <div class="label">${TranslationService.translate('repository-selector.tooltip.location')}:</div>
        <div class="value">${repository.location ? repository.location : TranslationService.translate('repository-selector.tooltip.local')}</div>
      </div>
      <div class="repository-tooltip-row">
        <div class="label">${TranslationService.translate('repository-selector.tooltip.type')}:</div>
        <div class="value">${TranslationService.translate('repository-selector.tooltip.types.' + (repository.type || 'unknown'))}</div>
      </div>
      <div class="repository-tooltip-row">
        <div class="label">${TranslationService.translate('repository-selector.tooltip.access')}:</div>
        <div class="value">${TranslationService.translate(this.canWriteRepo(repository) ? 'repository-selector.tooltip.accesses.read_write' : 'repository-selector.tooltip.accesses.read')}</div>
      </div>`;
        html += this.buildRepositorySizeInfoHtml(repositorySizeInfo);
        html += '</div>';
        return html;
    }
    /**
     * Builds the repository size section of the tooltip.
     */
    buildRepositorySizeInfoHtml(repositorySizeInfo) {
        if (!repositorySizeInfo || repositorySizeInfo.total < 0) {
            return '';
        }
        let html = `
    <div class="repository-tooltip-row total">
      <div class="label">${TranslationService.translate('repository-selector.tooltip.repository-size.total')}:</div>
      <div class="value">${this.totalTripletsFormatter.format(repositorySizeInfo.total)}</div>
    </div>`;
        if (repositorySizeInfo.explicit >= 0) {
            html += `
      <div class="repository-tooltip-row">
        <div class="label">${TranslationService.translate('repository-selector.tooltip.repository-size.explicit')}:</div>
        <div class="value">${this.totalTripletsFormatter.format(repositorySizeInfo.explicit)}</div>
      </div>`;
        }
        if (repositorySizeInfo.inferred >= 0) {
            html += `
      <div class="repository-tooltip-row">
        <div class="label">${TranslationService.translate('repository-selector.tooltip.repository-size.inferred')}:</div>
        <div class="value">${this.totalTripletsFormatter.format(repositorySizeInfo.inferred)}</div>
      </div>`;
        }
        if (repositorySizeInfo.total >= 0) {
            let value = '-';
            if (repositorySizeInfo.explicit > 0) {
                value = this.expansionRatioFormatter.format(repositorySizeInfo.total / repositorySizeInfo.explicit);
            }
            html += `
      <div class="repository-tooltip-row">
        <div class="label">${TranslationService.translate('repository-selector.tooltip.repository-size.expansion_ratio')}:</div>
        <div class="value">${value}</div>
      </div>`;
        }
        return html;
    }
    subscribeToTranslationChanged() {
        return [
            TranslationService.onTranslate('repository-selector.btn.toggle', [], (toggleButtonName) => {
                this.defaultToggleButtonName = toggleButtonName;
            }),
            TranslationService.onTranslate('repository-selector.btn.no_repositories', [], (noRepositoriesButtonMessage) => {
                this.noRepositoriesButtonMessage = noRepositoriesButtonMessage;
            })
        ];
    }
    onRepositoryChanged(selectedRepository) {
        this.repositoryContextService.updateSelectedRepository(selectedRepository);
    }
    getLocation() {
        var _a;
        if (!((_a = this.currentRepository) === null || _a === void 0 ? void 0 : _a.location)) {
            return '';
        }
        return `@${UriUtil.shortenIri(this.currentRepository.location)}`;
    }
    getButtonLabel() {
        var _a;
        return ((_a = this.items) === null || _a === void 0 ? void 0 : _a.length)
            ? this.defaultToggleButtonName
            : this.noRepositoriesButtonMessage;
    }
    static get watchers() { return {
        "items": ["onItemsChanged"]
    }; }
};
OntoRepositorySelector.style = ontoRepositorySelectorCss;

const ontoSearchIconCss = ".onto-search-icon{cursor:pointer;color:var(--gw-button-tertiary-icon-color);transition:all 0.15s ease-out}.onto-search-icon.ri-search-line{padding:0.5rem 0.8rem}.onto-search-icon:hover{transform:scale(1.2)}";

const OntoSearchIcon = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.tooltipKey = 'rdf_search.labels.search';
        this.subscriptions = new SubscriptionList();
    }
    // ========================
    // Lifecycle methods
    // ========================
    connectedCallback() {
        this.onTooltipChange();
    }
    disconnectedCallback() {
        this.subscriptions.unsubscribeAll();
    }
    render() {
        return (h("i", { key: 'e19266ec7de27b760ec4f348e3b1b2b721e44f99', "tooltip-content": this.tooltipLabel, "tooltip-placement": OntoTooltipPlacement.BOTTOM, class: "onto-search-icon ri-search-line ri-lg" }));
    }
    onTooltipChange() {
        this.subscriptions.add(TranslationService.onTranslate(this.tooltipKey, [], (translation) => this.tooltipLabel = translation));
    }
};
OntoSearchIcon.style = ontoSearchIconCss;

const ontoSearchResourceInputCss = ".search-resources-input{padding-right:20px}.search-resources-input .input-row{gap:3px;display:flex;flex-wrap:wrap}.search-resources-input .input-row .input-wrapper{position:relative;display:flex;flex:1;min-width:20vw}.search-resources-input .input-row .input-wrapper input{min-width:inherit;flex:1;padding:0.5rem 0.75rem;font-size:1rem;line-height:1.25;color:var(--gw-form-field-color);background-color:var(--gw-form-field-background);background-image:none;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid var(--gw-form-field-border-color)}.search-resources-input .input-row .input-wrapper input:focus{outline:0;color:var(--gw-form-field-color);border-color:var(--gw-form-field-focus-border-color)}.search-resources-input .input-row i.ri-close-line{position:absolute;right:10px;top:7px;z-index:10;font-size:1.6rem}.search-resources-input .input-row button{display:inline-block;font-weight:400;line-height:1.25;text-align:center;white-space:nowrap;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;transition:all 0.15s ease-out;user-select:none;border:1px solid transparent;padding:0.5rem 1rem;font-size:1rem;color:var(--gw-button-secondary-color);background-color:var(--gw-button-secondary-background)}.search-resources-input .input-row button.selected{background-color:var(--gw-button-primary-background);color:var(--gw-button-primary-color)}.search-resources-input .input-row button:focus{outline:none}.search-resources-input .input-row button:hover:not(.selected){background-color:var(--gw-button-secondary-hover-background);border-color:var(--gw-button-secondary-hover-color)}.search-resources-input .hint{font-size:0.8rem;color:#818a91}.search-resources-input .autocomplete-results-wrapper{margin-top:6px;max-height:204px;overflow:auto}.search-resources-input .autocomplete-results-wrapper p{font-size:1.1rem;line-height:1.5;color:var(--gw-autocomplete-color);background-color:var(--gw-autocomplete-background);margin-bottom:0;padding:5px 25px;cursor:pointer}.search-resources-input .autocomplete-results-wrapper p b{color:var(--gw-autocomplete-dropdown-match-color)}.search-resources-input .autocomplete-results-wrapper p.selected{color:var(--gw-autocomplete-option-selected-color);background-color:var(--gw-autocomplete-option-selected-background)}.search-resources-input .autocomplete-results-wrapper p.hovered:not(.selected),.search-resources-input .autocomplete-results-wrapper p:hover:not(.selected){color:var(--gw-autocomplete-option-focus-color);background-color:var(--gw-autocomplete-option-focus-background)}";

const OntoSearchResourceInput = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.autocompleteService = ServiceProvider.get(AutocompleteService);
        this.autocompleteContextService = ServiceProvider.get(AutocompleteContextService);
        this.autocompleteStorageService = ServiceProvider.get(AutocompleteStorageService);
        this.resourceSearchStorageService = ServiceProvider.get(ResourceSearchStorageService);
        this.toastrService = ServiceProvider.get(OntoToastrService);
        this.eventService = ServiceProvider.get(EventService);
        this.namespaceContextService = ServiceProvider.get(NamespacesContextService);
        this.subscriptions = new SubscriptionList();
        this.autocompleteWarningShown = false;
        /** Whether the rdf resource pre-search validation should be skipped. */
        this.skipValidation = false;
        /**
         * Whether the search component is currently hidden. Can be shown/hidden in the RDF search
         */
        this.isHidden = false;
        /**
         * Whether the autocomplete setting is enabled.
         */
        this.isAutocompleteEnabled = false;
        /**
         * Updates the local inputValue with the html input element's value.'
         */
        this.handleInput = (event) => {
            const target = event.target;
            if (!target.value) {
                this.clearInput();
                return;
            }
            this.setInputValue(target.value);
            this.checkForAutocomplete();
        };
        /**
         * Clears the search input field.
         */
        this.clearInput = () => {
            this.setInputValue('');
            if (this.preserveSearch) {
                this.resourceSearchStorageService.clearStoredSearch();
            }
        };
        this.onKeyDown = (event) => {
            switch (event.key) {
                case 'Enter':
                    this.onEnter(event);
                    break;
                case 'Escape':
                    this.onEscape();
                    break;
                case 'ArrowUp':
                    this.onArrowUp(event);
                    break;
                case 'ArrowDown':
                    this.onArrowDown(event);
                    break;
            }
        };
    }
    onVisibilityChange(isHidden) {
        var _a;
        if (isHidden) {
            (_a = this.searchResult) === null || _a === void 0 ? void 0 : _a.clearSuggestions();
        }
        else {
            this.setInputValue(this.resourceSearchStorageService.getInputValue());
        }
    }
    connectedCallback() {
        this.onAutocompleteEnabledChange();
        this.onNamespaceChange();
        this.loadInputFromStorage();
    }
    disconnectedCallback() {
        this.subscriptions.unsubscribeAll();
    }
    render() {
        var _a, _b, _c;
        return (h("section", { key: '2aef113dce7a1732d7aa9a276d67428fe57dc8ca', class: "search-resources-input" }, h("div", { key: '4370040b1848a6ec96b87425d76c13e750eb3fdd', class: "input-row" }, h("span", { key: '88a3f8e9d61e7f7e4146d7b261afbe64417049a7', class: "input-wrapper" }, h("input", { key: '979d6443b7e569d7f1cbd6a3ea22201ad4df163e', value: this.inputValue, id: this.context, type: "text", autocomplete: "off", placeholder: `${TranslationService.translate('rdf_search.labels.search')}...`, ref: (ref) => this.inputRef = ref, onKeyDown: this.onKeyDown, "data-test": this.context, onInput: this.handleInput }), ((_a = this.inputValue) === null || _a === void 0 ? void 0 : _a.length) ?
            h("i", { onClick: this.clearInput, "tooltip-content": TranslationService.translate('rdf_search.tooltips.clear'), "tooltip-placement": OntoTooltipPlacement.BOTTOM, class: "ri-close-line clear-input" }) : ''), (_b = this.buttonConfig) === null || _b === void 0 ? void 0 :
            _b.getButtons().getItems().map((button) => (h("button", { key: button.label, onClick: this.handleButtonClick(button), class: `${button.selected ? 'selected' : ''}` }, button.label)))), h("span", { key: '738954c1aa3259ef458708e02a45971c4c52c8ce', class: "hint" }, TranslationService.translate('rdf_search.labels.hint')), h("section", { key: 'a6ae231bf3554e94429618431b98cefc78415219', class: "autocomplete-results-wrapper", "data-test": 'onto-autocomplete-results' }, (_c = this.searchResult) === null || _c === void 0 ? void 0 : _c.suggestions.getItems().map((suggestion) => (h("p", { key: suggestion.getId(), onClick: this.onSuggestionClick(suggestion), "data-test": 'onto-autocomplete-suggestion', onMouseMove: this.hoverSuggestion(suggestion), class: `${suggestion.isHovered() ? 'hovered' : ''} ${suggestion.isSelected() ? 'selected' : ''}`, innerHTML: suggestion.getDescription() }))))));
    }
    /**
     * Handles the click event for a search button.
     * If the button configuration is set to radio mode and the clicked button is not selected,
     * it deselects all other buttons and selects the clicked one.
     * @param {SearchButton} button - The button that was clicked.
     */
    handleButtonClick(button) {
        return () => this.buttonConfig = this.buttonConfig.selectButton(button);
    }
    loadAutocompleteResults() {
        var _a;
        if (!this.inputValue) {
            (_a = this.searchResult) === null || _a === void 0 ? void 0 : _a.clearSuggestions();
            return;
        }
        if (this.isAutocompleteEnabled) {
            this.autocompleteService.search(this.inputValue)
                .then((searchResult) => {
                this.onResultsReceived(searchResult);
            });
        }
    }
    hoverSuggestion(suggestion) {
        return () => this.searchResult = this.searchResult.hoverSuggestion(suggestion);
    }
    onAutocompleteEnabledChange() {
        this.isAutocompleteEnabled = this.autocompleteStorageService.isEnabled();
        this.subscriptions.add(this.autocompleteContextService.onAutocompleteEnabledChanged((enabled) => {
            this.isAutocompleteEnabled = enabled !== null && enabled !== void 0 ? enabled : this.isAutocompleteEnabled;
        }));
    }
    checkForAutocomplete() {
        if (this.inputValue.length > 0 && !this.isAutocompleteEnabled && !this.autocompleteWarningShown) {
            this.autocompleteWarningShown = true;
            const message = TranslationService.translate('rdf_search.toasts.autocomplete_is_off');
            this.toastrService.warning(`<a class="no-underline" style="font-weight: 500">${message}</a>`, {
                onClick: navigateTo('autocomplete'),
                removeOnClick: true
            });
        }
    }
    onSuggestionClick(suggestion) {
        return (event) => {
            suggestion.setOverrideToVisual(event.ctrlKey || event.metaKey);
            this.searchRdfResource(suggestion);
        };
    }
    searchRdfResource(suggestion) {
        if (suggestion.getType() === SuggestionType.PREFIX) {
            this.expandPrefix(suggestion);
        }
        else {
            this.notifyRdfResourceSelected(suggestion);
            if (this.preserveSearch) {
                this.resourceSearchStorageService.setLastSelected(suggestion);
            }
        }
    }
    notifyRdfResourceSelected(suggestion) {
        var _a;
        this.searchResult = (_a = this.searchResult) === null || _a === void 0 ? void 0 : _a.selectSuggestion(suggestion);
        this.eventService.emit({
            NAME: ResourceSearchConstants.SUGGESTION_SELECTED_EVENT,
            payload: new SuggestionSelectedPayload(suggestion, this.context)
        });
    }
    expandPrefix(suggestion) {
        this.setInputValue(this.namespaces.getByPrefix(suggestion.getValue()));
        this.inputRef.focus();
    }
    setInputValue(value) {
        this.inputValue = value;
        if (this.preserveSearch) {
            this.resourceSearchStorageService.setInputValue(this.inputValue);
        }
        this.loadAutocompleteResults();
    }
    onNamespaceChange() {
        this.subscriptions.add(this.namespaceContextService.onNamespacesChanged((namespaces) => {
            this.namespaces = namespaces;
        }));
    }
    onEnter(event) {
        var _a;
        let selectedSuggestion = (_a = this.searchResult) === null || _a === void 0 ? void 0 : _a.getHoveredSuggestion();
        if (!selectedSuggestion) {
            selectedSuggestion = new Suggestion({
                value: UriUtil.removeAngleBrackets(this.inputValue),
                type: SuggestionType.URI
            });
        }
        selectedSuggestion.setOverrideToVisual(event.ctrlKey || event.metaKey);
        this.validateAndSearch(selectedSuggestion);
    }
    onArrowUp(event) {
        if (!this.searchResult) {
            return;
        }
        this.searchResult = this.searchResult.hoverPreviousSuggestion();
        this.displaySuggestion(event);
    }
    onArrowDown(event) {
        if (!this.searchResult) {
            return;
        }
        this.searchResult = this.searchResult.hoverNextSuggestion();
        this.displaySuggestion(event);
    }
    displaySuggestion(event) {
        event.preventDefault();
        // Update the input directly, because the value should only be displayed,
        // without triggering a new search and altering the autocomplete results
        this.inputRef.value = this.searchResult.getHoveredSuggestion().getValue();
        this.scrollToSuggestionBySelector('p.hovered');
    }
    getSuggestionValue(suggestion) {
        return suggestion.getType() === SuggestionType.PREFIX
            ? this.namespaces.getByPrefix(suggestion.getValue())
            : suggestion.getValue();
    }
    scrollToSuggestionBySelector(selector, options) {
        HtmlUtil.waitForElement(selector)
            .then(() => {
            HtmlUtil.scrollElementIntoView(selector, options);
        });
    }
    validateAndSearch(suggestion) {
        if (!this.skipValidation) {
            if (!suggestion.getValue()) {
                this.toastrService.error(TranslationService.translate('rdf_search.toasts.empty_input'));
                return;
            }
            if (!UriUtil.isValidUri(this.getSuggestionValue(suggestion))) {
                this.toastrService.error(TranslationService.translate('rdf_search.toasts.invalid_uri'));
                return;
            }
        }
        this.searchRdfResource(suggestion);
    }
    onEscape() {
        if (this.preserveSearch) {
            return;
        }
        this.clearInput();
    }
    loadInputFromStorage() {
        if (!this.preserveSearch) {
            return;
        }
        this.inputValue = this.resourceSearchStorageService.getInputValue() || '';
    }
    onResultsReceived(searchResult) {
        const lastSelected = searchResult === null || searchResult === void 0 ? void 0 : searchResult.getByValue(this.resourceSearchStorageService.getLastSelectedValue());
        if (lastSelected && this.preserveSearch) {
            // No need to reassign twice in the same thread tick. One will trigger the re-render
            searchResult.hoverSuggestion(lastSelected);
            this.searchResult = searchResult.selectSuggestion(lastSelected);
            this.scrollToSuggestionBySelector('p.hovered.selected', { block: 'start' });
        }
        else {
            this.searchResult = searchResult.hoverFirstSuggestion();
            this.scrollToSuggestionBySelector('p.hovered', { block: 'start' });
        }
    }
    static get watchers() { return {
        "isHidden": ["onVisibilityChange"]
    }; }
};
OntoSearchResourceInput.style = ontoSearchResourceInputCss;

const ontoUserLoginCss = ".onto-user-login{position:relative;width:fit-content}.onto-user-login button{display:flex;color:var(--gw-button-tertiary-color);background-color:var(--gw-button-tertiary-background);flex-direction:row;line-height:1.5;font-weight:400;font-size:1rem;text-align:center;user-select:none;border:1px solid transparent;padding:0.4em 1rem;cursor:pointer;white-space:nowrap;place-items:center;transition:all 0.15s ease-out}.onto-user-login button .user-login-label{padding:0 0.4rem}.onto-user-login button:hover{color:var(--gw-button-tertiary-hover-color);background-color:var(--gw-button-tertiary-hover-background)}.onto-user-login button:hover .ri-user-fill{transform:scale(1.2)}.onto-user-login button:focus{outline:none}.onto-user-login button i{color:var(--user-menu-primary-color);line-height:0.75;font-size:1.2em;transition:0.15s ease-out}.onto-user-login button i.ri-arrow-down-s-line{color:rgba(0, 0, 0, 0.35);font-size:1.1em;transition:all 0.2s ease-in}";

const OntoUserLogin = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
    }
    navigateToLogin() {
        return (event) => {
            event.preventDefault();
            const returnUrl = encodeURIComponent(getCurrentRoute());
            navigate(`login?r=${encodeURIComponent(returnUrl)}`);
        };
    }
    render() {
        return (h("section", { key: '65c270b9b0df6412e1304791bd1ab1e69dc15b67', class: "onto-user-login" }, h("button", { key: '75f75cf70572cd7b2e39532fc607f168d36ccedf', onClick: this.navigateToLogin() }, h("i", { key: '1af92e3294047a2ae00a35b69bfe1db0348dc755', class: "ri-arrow-right-circle-line" }), h("translate-label", { key: '5c8c78df37825e7a56f024fff351c69778bafa01', class: "user-login-label", labelKey: "user_menu.login" }))));
    }
};
OntoUserLogin.style = ontoUserLoginCss;

const ontoUserMenuCss = ".onto-user-menu{position:relative;width:fit-content}.onto-user-menu button{display:flex;flex-direction:row;line-height:1.5;font-weight:400;font-size:1rem;text-align:center;user-select:none;padding:0.4em 1rem;cursor:pointer;white-space:nowrap;place-items:center;transition:all 0.15s ease-out;background-color:transparent;color:var(--gw-button-tertiary-color);border:1px solid var(--gw-button-tertiary-border-color)}.onto-user-menu button .ri-user-line,.onto-user-menu button .ri-arrow-down-s-line{color:var(--gw-button-tertiary-icon-color)}.onto-user-menu button:hover{background-color:var(--gw-button-tertiary-hover-background);color:var(--gw-button-tertiary-hover-color);border:1px solid var(--gw-button-tertiary-hover-border-color)}.onto-user-menu button:hover .ri-user-line{transform:scale(1.2)}.onto-user-menu button:focus{outline:none}.onto-user-menu button.open{color:var(--gw-button-primary-color);background-color:var(--gw-button-primary-background)}.onto-user-menu button.open .ri-user-line,.onto-user-menu button.open .ri-arrow-down-s-line{color:var(--gw-button-primary-color)}.onto-user-menu button.open:hover{color:var(--gw-button-primary-hover-color);background-color:var(--gw-button-primary-hover-background);border-color:var(--gw-button-primary-hover-border-color)}.onto-user-menu button.open:hover .ri-user-line{transform:scale(1.2)}.onto-user-menu button .username{padding:0 5px}.onto-user-menu button i{transition:0.15s ease-out}.onto-user-menu button i.ri-arrow-down-s-line{font-size:1.1em;transition:all 0.2s ease-in}.onto-user-menu .onto-user-menu-dropdown{position:absolute;z-index:1000;display:flex;flex-direction:column;cursor:pointer;text-decoration:none;right:0;min-width:7rem;font-size:1rem;width:100%;color:var(--gw-tieredmenu-color);background-color:var(--gw-tieredmenu-background);border:1px solid var(--gw-tieredmenu-border-color);box-shadow:var(--gw-tieredmenu-shadow-1-offset-x) var(--gw-tieredmenu-shadow-1-offset-y) var(--gw-tieredmenu-shadow-1-blur) var(--gw-tieredmenu-shadow-1-spread) var(--gw-tieredmenu-shadow-1-color)}.onto-user-menu .onto-user-menu-dropdown translate-label{padding:0.4rem 1rem;user-select:none;white-space:nowrap;font-weight:400}.onto-user-menu .onto-user-menu-dropdown translate-label:hover{color:var(--gw-tieredmenu-item-focus-color);background-color:var(--gw-tieredmenu-item-focus-background)}";

const OntoUserMenu = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.authenticationService = service(AuthenticationService);
        /**
        * Log out the current user.
        */
        this.logout = () => {
            this.authenticationService.logout();
        };
        /**
         * Toggles the dropdown menu's open state.
         *
         * @returns A function that toggles the `isOpen` state between true and false.
         */
        this.toggleDropdown = () => {
            this.isOpen = !this.isOpen;
        };
        /**
         * Closes the dropdown if the user clicks outside the component.
         */
        this.handleOutsideClick = (event) => {
            if (this.isOpen && !this.hostElement.contains(event.target)) {
                this.isOpen = false;
            }
        };
    }
    connectedCallback() {
        document.addEventListener('click', this.handleOutsideClick);
    }
    disconnectedCallback() {
        document.removeEventListener('click', this.handleOutsideClick);
    }
    render() {
        return (h("section", { key: '1dab3b6df2cdbc139eb9c449a8a91bf016b45831', class: 'onto-user-menu' }, h("div", { key: '1050af1eb93e599a16fda17448abb77ebeacade4', class: 'dropdown-toggle-wrapper', onClick: this.toggleDropdown }, h("button", { key: 'b98b83e32ed1d861f76d0e51a0040ccea992da73', class: `${this.isOpen ? 'open' : ''}` }, h("i", { key: '47f321878b2c806a9aa0c65db7c2a2da900233af', class: 'ri-user-line ri-lg' }), h("span", { key: 'a2017e3a4b837206ff8860404b8766054d288a50', class: 'username' }, this.user.username), h("i", { key: '5bac7282c450c74d205dca06697b79aaa888a6e3', class: `ri-arrow-down-s-line ${this.isOpen ? 'rotate-180' : ''}` })), this.isOpen ?
            h("section", { class: 'onto-user-menu-dropdown' }, h("translate-label", { onClick: navigateTo('settings'), labelKey: 'user_menu.my_settings' }), !this.authenticationService.isExternalUser() ?
                h("translate-label", { onClick: this.logout, labelKey: 'user_menu.logout' }) : '') : '')));
    }
    get hostElement() { return getElement(this); }
};
OntoUserMenu.style = ontoUserMenuCss;

export { OntoLanguageSelector as onto_language_selector, OntoLicenseAlert as onto_license_alert, OntoOperationsNotification as onto_operations_notification, OntoRdfSearch as onto_rdf_search, OntoRepositorySelector as onto_repository_selector, OntoSearchIcon as onto_search_icon, OntoSearchResourceInput as onto_search_resource_input, OntoUserLogin as onto_user_login, OntoUserMenu as onto_user_menu };
